import Map from "../Components/Map";

const Orientation = () => {
    return (
        <Map/>
    )
}

export default Orientation;
